export default {
  default: "default",
  login: "login",
  noSidebar: "noSidebar",
};
